import { FormActions, VersionFormFields } from '@common*';
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useBatchEditRentalConfigurationFormSchema } from './hooks';
import { BatchEditRentalConfigurationFormValuesType } from './types';

type BatchEditRentalConfigurationFormPropsType = {
  onCancel: () => void;
  onSave: (data: BatchEditRentalConfigurationFormValuesType) => void;
};

export const BatchEditRentalConfigurationForm: React.FC<
  BatchEditRentalConfigurationFormPropsType
> = ({ onCancel, onSave }) => {
  const { t } = useTranslation('venueDetailsRental');
  const { schema, defaultValues } = useBatchEditRentalConfigurationFormSchema();

  const methods = useForm<BatchEditRentalConfigurationFormValuesType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSave)}>
        <Stack gap="md">
          <VersionFormFields />
          <FormActions
            onCancel={onCancel}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
